<div class="stepper-body">
    <div class="body-title">
        <span>Let's get started!</span>
    </div>
    <div class="body-description">
        <span>What are you interested in?</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(LoanPurposeOptions.Purchase)
                        }" (click)="onAnswerSelected(LoanPurposeOptions.Purchase)">
                {{LoanPurposeOptions.Purchase}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(LoanPurposeOptions.Refinance)
                        }" (click)="onAnswerSelected(LoanPurposeOptions.Refinance)">
                {{LoanPurposeOptions.Refinance}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button [style.visibility]="isDialog ? 'visible' : 'hidden'" mat-stroked-button color="primary"
            (click)="onClose()" class="step-button secondary" [disabled]="false">
            Close
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>